// src/pages/Servicios.js
import React, { useEffect, useState } from 'react';
import '../styles/servicios.css';

export default function Servicios() {
    const [data, setData] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let cancelado = false;

        (async () => {
            try {
                const r = await fetch('/data/servicios.json', { cache: 'no-store' });
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const json = await r.json();
                if (cancelado) return;
                setData(json);
                if (json?.seoTitle) document.title = json.seoTitle; // título desde JSON
            } catch (e) {
                console.error('[Servicios] Error cargando /data/servicios.json:', e);
                if (!cancelado) {
                    setError(true);
                    setData(null);
                }
            } finally {
                if (!cancelado) setCargando(false);
            }
        })();

        return () => { cancelado = true; };
    }, []);

    // 1) Cargando: aún no tenemos el JSON → evitamos texto hardcodeado
    if (cargando || !data) {
        return (
            <div className="servicios-wrapper" aria-busy="true" style={{ minHeight: 120 }} />
        );
    }

    // 2) Error: ya hay data de UI → usamos textos desde JSON
    if (error) {
        return (
            <div className="servicios-wrapper">
                <p className="intro-servicios" role="alert">{data.ui?.loadError}</p>
            </div>
        );
    }

    const items = Array.isArray(data.items) ? data.items : [];

    return (
        <div className="servicios-wrapper">
            {/* H1 controlado por JSON */}
            <h1 className="titulo-servicios">{data.sectionTitle}</h1>
            <hr className="linea-separadora" />

            {data.intro && <p className="intro-servicios">{data.intro}</p>}

            {items.length === 0 ? (
                <p className="intro-servicios">{data.ui?.emptyText}</p>
            ) : (
                <div className="servicios-grid">
                    {items.map((s, idx) => {
                        // Permite usar ruta absoluta (empieza con "/") o solo el nombre del archivo
                        const iconSrc = s.icono
                            ? (s.icono.startsWith('/') ? s.icono : `/imgs/${s.icono}`)
                            : null;

                        return (
                            <div className="servicio-cubo" key={idx}>
                                {iconSrc && (
                                    <img
                                        src={iconSrc}
                                        alt={s.titulo || data.ui?.iconAltDefault}
                                        className="icono-servicio"
                                        loading="lazy"
                                    />
                                )}
                                <h3>{s.titulo}</h3>
                                <p>{s.descripcion}</p>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
